import { useQuery } from "@tanstack/react-query";

import { useAppSelector } from "Hooks/useRedux";

import Api from "Api";

export default function useMarginPark() {
  const { visible, selectedZones, selectedSubZones } = useAppSelector((state) => state.marginPark);
  const { date } = useAppSelector((state) => state.filters);

  const statusQuery = () => {
    return "status=enable";
  };
  const nameQuery = () => {
    return "type=car";
  };

  console.log(selectedZones, selectedSubZones, "iyhbjhuybjhu");

  const dataForPost = {
    ScenarioUniqueId: "8219b30d-fbad-4e73-b9c1-36b01326461b",
    ServiceUniqueId: "a0a68bd6-6804-4ef2-bd3d-b05fa930c73e",
    IncludeNonServiceBranches: false,
    Parameters: {
      "b8322332-7f01-11ef-8d00-1062eb32e4ff": selectedSubZones,
      "b8322331-7f01-11ef-8d00-1062eb32e4ff": selectedZones.map((z) => z.id),
      "32f530c3-12e3-443d-a8d2-26d4fe557274": date.created_after || "2020-06-03",
      "0c9a07bc-24a3-4d1d-90e8-d458d6e14870": date.created_before || "2025-06-03",
    },
    InputTables: [],
    OutputColumns: [],
  };

  const { data, refetch, isLoading, isFetching } = useQuery({
    queryKey: [visible, selectedZones, selectedSubZones],
    queryFn: () => {
      return Api.sPost(
        "https://report2.ardban.ir:7072/https://report2.ardban.ir:8080/gateway/MSSE.DIA/api/ScenarioServiceCallApi/ShortTimeServiceExecute",
        dataForPost
      ).then((res) => {
        console.log(res.data.Rows, "jytsjc");
        return res.data.Rows;
      });
    },
    enabled: visible,
  });

  return { data, isLoading, refetch, isFetching };
}
